import { render, staticRenderFns } from "./StoreEditViewPratica.vue?vue&type=template&id=cfbfbf78&scoped=true"
import script from "./StoreEditViewPratica.vue?vue&type=script&lang=js"
export * from "./StoreEditViewPratica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbfbf78",
  null
  
)

export default component.exports